import { useEffect, useState } from 'react';

import { Text } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

const BenefitsContainer = styled.ul`
  position: relative;
  padding: 0;

  & > li:not(:first-of-type) {
    position: absolute;
    top: 0;
  }
`;

const Benefit = styled.li`
  width: 100%;
  text-align: center;
  opacity: 0;
  list-style-type: none;
  transition: opacity 0.3s;

  &.is-visible {
    opacity: 1;
  }
`;

type Props = {
  benefits: string[];
};

export const AnimatedBenefits = ({ benefits }: Props) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % benefits.length);
    }, 2200);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <BenefitsContainer>
      {benefits !== null &&
        benefits.map((benefit, index) => (
          <Benefit key={benefit} className={index === activeIndex ? 'is-visible' : ''}>
            <Text align="center" variant="labelMd">
              {benefit}
            </Text>
          </Benefit>
        ))}
    </BenefitsContainer>
  );
};
